import classNames from 'classnames';

import style from './TaskSection.module.scss';

import { TaskSectionTitle } from './TaskSectionTitle';

interface Props {
    showIf?: boolean;
    divider?: boolean;
    title?: string;
    titleAction?: React.ReactNode;
    className?: string;
    rowGap?: number;
    children: React.ReactNode | React.ReactNode[];
}

export function TaskSection({
    showIf = true,
    divider,
    title,
    titleAction,
    className,
    rowGap,
    children,
}: Props): React.ReactElement<any> | null {
    return showIf ? (
        <div className={classNames([divider && style.divider, className])}>
            {title && (
                <TaskSectionTitle
                    title={title}
                    action={titleAction}
                />
            )}
            <div
                className={style.items}
                style={{ rowGap }}
            >
                {children}
            </div>
        </div>
    ) : null;
}
